import './Categoryitem.scss';
function Categoryitem(props: any) {

  const checkFunction = (data:any) =>{
          props.movetoAllProducts(data)
}

  return (
    <div>
      {props.type === 'largecategory' ? (
        <div  className=' touchAble cm-1rem '>
          <img className='category-item-image border-radius' alt="img" src={'https://lesfemmestesting.dominioninc.org/public/uploads/images/' + props.DataofProduct.image} ></img>
          <div className='cp-t-1rem secHeading  text-center primary-color'>
            {props.DataofProduct.name}
          </div>
        </div>
      ) : (
        <div  className=' touchAble d-flex flex-row flex-wrap justify-content-center' >
          {props.Dataof.map((person: any) => (
            <div onClick={()=>checkFunction(person)} key={person.id} className='cm-t-2rem cp-l-1rem cp-r-1rem display-flex col-flex content-center align-item-center'>
              <div style={{}}>
                {props.brands === true?(
                  <img className='category-image' alt="img" src={'https://lesfemmestesting.dominioninc.org/public/uploads/images/' + person.image} ></img>
                ):(
                  <img className='category-image' alt="img" src={'https://lesfemmestesting.dominioninc.org/public/uploads/shortcuts/' + person.picture} ></img>
                ) }
              </div>
              <div className=' text-center pText category-text'>
                {person.name}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

  );
}
export default Categoryitem;
